<template>
  <div v-loading="dataLoading" class="app-content-wrapper">
    <div class="notify-box">
      <div class="notify-top">
        <div class="">
          <span class="margin-right-9 notify-title">{{$t('message.developer.alertNotifyTitle')}}</span>
          <el-popover :placement="'right'" trigger="click" :content="$t('message.developer.alertNotifyTips')" class="i-popover">
            <span class="iconfont icon-tishi003" slot="reference"></span>
          </el-popover>
        </div>
        <el-button v-if="!operation.isEditEnrollmentNotify" size="small" icon="iconfont icon-caozuo-bianji" @click="handleOperationClick('isEditEnrollmentNotify')">
          {{$t('message.common.edit')}}
        </el-button>
        <el-button v-if="operation.isEditEnrollmentNotify" type="primary" size="small" icon="iconfont icon-caozuo-wancheng1" @click="handleSaveEnrollmentNotify">
          {{$t('message.common.save')}}
        </el-button>
      </div>
      <div class="notify-content">
        <el-form label-position="top">
          <el-form-item :label="$t('message.developer.notifyStatus')">
            <template v-if="operation.isEditEnrollmentNotify">
              <el-checkbox-group v-model="checkStatusList">
                <el-checkbox v-for="item in enrollmentStatusList" :key="item.value" :label="item.value">{{item.label}}</el-checkbox>
              </el-checkbox-group>
            </template>
            <template v-else>
              <span v-if="checkStatusList.length === 0">{{$t('message.common.none')}}</span>
              <span v-else>
                <span v-for="(status, index) in checkStatusList" :key="status">
                  {{ getStatusLabel(status) }}
                  <span v-if="index < checkStatusList.length - 1">、</span>
                </span>
              </span>
            </template>
          </el-form-item>
          <el-form-item :label="operation.isEditEnrollmentNotify ? $t('message.developer.selectNotifyType') : $t('message.developer.notifyType')">
            <template v-if="operation.isEditEnrollmentNotify">
              <div class="notify-item">
                <el-checkbox v-model="isWebhookChecked" label="Webhook">{{$t('message.developer.webhook')}}</el-checkbox>
                <el-input v-if="isWebhookChecked" v-model="notifyWebhook" class="value-input" :placeholder="$t('message.validator.input', { input: $t('message.developer.webhook') })" />
              </div>
              <div class="notify-item margin-top-10">
                <el-checkbox v-model="isEmailChecked" label="Email">{{$t('message.developer.email')}}</el-checkbox>
                <el-input v-if="isEmailChecked" v-model="notifyEmail" class="value-input" :placeholder="$t('message.validator.input', { input: $t('message.developer.email') })" />
              </div>
            </template>
            <template v-else>
              <span v-if="!isWebhookChecked && !isEmailChecked">{{$t('message.common.none')}}</span>
              <div v-else>
                <div v-if="isWebhookChecked">
                  {{$t('message.developer.webhook')}}: {{notifyWebhook}}
                </div>
                <div v-if="isEmailChecked">
                  {{$t('message.developer.email')}}: {{notifyEmail}}
                </div>
              </div>
            </template>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- <div class="notify-box">
      <div class="notify-top">
        <div class="">
          <span class="margin-right-9 notify-title">{{$t('message.developer.alertFailureNotifyTitle')}}</span>
          <el-popover :placement="'right'" trigger="click" :content="$t('message.developer.alertFailureNotifyTips')" class="i-popover">
            <span class="iconfont icon-tishi003" slot="reference"></span>
          </el-popover>
        </div>
        <el-button v-if="!operation.isEditMalfunctionNotify" size="small" icon="iconfont icon-caozuo-bianji" @click="handleOperationClick('isEditMalfunctionNotify')">
          {{$t('message.common.edit')}}
        </el-button>
        <el-button v-if="operation.isEditMalfunctionNotify" type="primary" size="small" icon="iconfont icon-caozuo-wancheng1" @click="handleOperationClick('isEditMalfunctionNotify')">
          {{$t('message.common.save')}}
        </el-button>
      </div>
      <div class="notify-content">
        <el-form label-position="top">
          <el-form-item :label="$t('message.developer.selectNotifyType')">
            <template v-if="operation.isEditMalfunctionNotify">
              <div class="notify-item margin-top-10">
                <el-checkbox v-model="isEmailChecked" label="Email">{{$t('message.developer.email')}}</el-checkbox>
                <el-input v-if="isEmailChecked" v-model="notifyEmail" class="value-input" :placeholder="$t('message.validator.input', { input: $t('message.developer.email') })" />
              </div>
            </template>
            <template v-else>
              无
            </template>
          </el-form-item>
        </el-form>
      </div>
    </div> -->
    <div class="notify-box" v-if="profile?.enableEthocaProxyAlertNotify === 'true' || profile?.enableRdrProxyAlertNotify === 'true'||profile?.enableEthocaProxyAlertNotify === true || profile?.enableRdrProxyAlertNotify === true">
      <div class="notify-top">
        <div class="">
          <span class="margin-right-9 notify-title">{{$t('message.developer.ethocaAlertTitle')}}</span>
          <el-popover :placement="'right'" trigger="click" :content="$t('message.developer.ethocaAlertTips')" class="i-popover">
            <span class="iconfont icon-tishi003" slot="reference"></span>
          </el-popover>
        </div>
        <el-button v-if="!operation.isEditEthocaAlerts" v-permission="'developer:notify:edit'" size="small" icon="iconfont icon-caozuo-bianji" @click="handleOperationClick('isEditEthocaAlerts')">
          {{$t('message.common.edit')}}
        </el-button>
        <el-button v-if="operation.isEditEthocaAlerts" type="primary" size="small" icon="iconfont icon-caozuo-wancheng1" @click="handleSaveEthocaAlerts">
          {{$t('message.common.save')}}
        </el-button>
      </div>
      <div class="notify-content">
        <el-form label-position="top">
          <el-form-item :label="operation.isEditEthocaAlerts ? $t('message.developer.selectNotifyType') : $t('message.developer.notifyType')">
            <template v-if="operation.isEditEthocaAlerts">
              <div class="notify-item">
                <el-checkbox v-model="isEthocaWebhookChecked" label="Webhook">{{$t('message.developer.webhook')}}</el-checkbox>
                <el-input v-if="isEthocaWebhookChecked" v-model="notifyEthocaWebhook" class="value-input" :placeholder="$t('message.validator.input', { input: $t('message.developer.webhook') })" />
              </div>
            </template>
            <template v-else>
              {{ isEthocaWebhookChecked ? $t('message.developer.webhook') : $t('message.common.none')}}
            </template>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="notify-box" v-if="profile?.enableRdrProxyAlertNotify === 'true' || profile?.enableEthocaProxyAlertNotify === 'true' || profile?.enableRdrProxyAlertNotify === true || profile?.enableEthocaProxyAlertNotify === true">
      <div class="notify-top">
        <div class="">
          <span class="margin-right-9 notify-title">{{$t('message.developer.rdrAlertTitle')}}</span>
          <el-popover :placement="'right'" trigger="click" :content="$t('message.developer.rdrAlertTips')" class="i-popover">
            <span class="iconfont icon-tishi003" slot="reference"></span>
          </el-popover>
        </div>
        <el-button v-if="!operation.isEditRDRCases" v-permission="'developer:notify:edit'" size="small" icon="iconfont icon-caozuo-bianji" @click="handleOperationClick('isEditRDRCases')">
          {{$t('message.common.edit')}}
        </el-button>
        <el-button v-if="operation.isEditRDRCases" type="primary" size="small" icon="iconfont icon-caozuo-wancheng1" @click="handleSaveRDRCases">
          {{$t('message.common.save')}}
        </el-button>
      </div>
      <div class="notify-content">
        <el-form label-position="top">
          <el-form-item :label="operation.isEditRDRCases ? $t('message.developer.selectNotifyType') : $t('message.developer.notifyType')">
            <template v-if="operation.isEditRDRCases">
              <div class="notify-item">
                <el-checkbox v-model="isRDRSFTPChecked" label="SFTP">SFTP</el-checkbox>
                <!-- <el-input v-if="isRDRSFTPChecked" v-model="notifyRDRSFTP" class="value-input" placeholder="输入通知地址" /> -->
              </div>
            </template>
            <template v-else>
              {{ isRDRSFTPChecked ? 'SFTP' : $t('message.common.none')}}
            </template>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="notify-box">
      <div class="notify-top">
        <div class="">
          <span class="margin-right-9 notify-title">{{$t('message.developer.fraudNotifyTitle')}}</span>  <!-- 欺诈通知标题 -->
          <el-popover :placement="'right'" trigger="click" :content="$t('message.developer.fraudNotifyTips')" class="i-popover">  <!-- 气泡提示框，显示欺诈通知的描述信息 -->
            <span class="iconfont icon-tishi003" slot="reference"></span>  <!-- 提示图标 -->
          </el-popover>
        </div>
        <el-button v-if="!operation.isEditFraudNotify" v-permission="'developer:notify:edit'" size="small" icon="iconfont icon-caozuo-bianji" @click="handleOperationClick('isEditFraudNotify')">  <!-- 编辑按钮，仅在非编辑状态且有权限时显示 -->
          {{$t('message.common.edit')}}
        </el-button>
        <el-button v-if="operation.isEditFraudNotify" type="primary" size="small" icon="iconfont icon-caozuo-wancheng1" @click="handleSaveFraudNotify">  <!-- 保存按钮，仅在编辑状态时显示 -->
          {{$t('message.common.save')}}
        </el-button>
      </div>
      <div class="notify-content">
        <el-form label-position="top">
          <el-form-item :label="operation.isEditFraudNotify ? $t('message.developer.selectNotifyType') : $t('message.developer.notifyType')">  <!-- 表单项标签，根据编辑状态显示不同文本 -->
            <template v-if="operation.isEditFraudNotify">  <!-- 编辑状态时的模板 -->
              <div class="notify-item">
                <el-checkbox v-model="isFraudWebhookChecked" label="Webhook">{{$t('message.developer.webhook')}}</el-checkbox>  <!-- Webhook选择框 -->
                <el-input v-if="isFraudWebhookChecked" v-model="notifyFraudWebhook" class="value-input" :placeholder="$t('message.validator.input', { input: $t('message.developer.webhook') })" />  <!-- Webhook地址输入框，仅在选中Webhook时显示 -->
              </div>
            </template>
            <template v-else>  <!-- 非编辑状态时的模板 -->
              <span v-if="!isFraudWebhookChecked">{{$t('message.common.none')}}</span>  <!-- 未选择任何通知方式时显示"无" -->
              <div v-else>
                <div v-if="isFraudWebhookChecked">  <!-- 选中Webhook时显示Webhook地址 -->
                  {{$t('message.developer.webhook')}}: {{notifyFraudWebhook}}
                </div>
              </div>
            </template>
          </el-form-item>
        </el-form>
      </div>
    </div>

  </div>
</template>

<script>
import { updateMerchantProfile } from '@/api/common/user';
import { ShowSuccessMessage, ShowErrorMessage } from '@/components/modal/tips/message-tips';
import GlobalData from '@/utils/global';
import { initSelectedData } from '@/utils/tools/constant';
import AccountInfo from '@/views/account/information/api/account-info';

export default {
  name: 'DeveloperNotifyComponent',
  data() {
    return {
      dataLoading: false,
      checkStatusList: [],
      enrollmentStatusList: [],
      isWebhookChecked: false,
      isEmailChecked: false,
      isEthocaWebhookChecked: false,
      isRDRSFTPChecked: false,
      isFraudWebhookChecked: false, // 是否选中欺诈通知Webhook选项
      notifyWebhook: '',
      notifyEmail: '',
      notifyEthocaWebhook: '',
      notifyRDRSFTP: '',
      notifyFraudWebhook: '', // 欺诈通知Webhook地址
      operation: {
        isEditEnrollmentNotify: false,
        isEditMalfunctionNotify: false,
        isEditEthocaAlerts: false,
        isEditRDRCases: false,
        isEditFraudNotify: false, // 欺诈通知编辑状态标志
      },
      profile: {},
    };
  },
  mounted() {
    this.initMethod();
  },
  methods: {
    async initMethod() {
      this.dataLoading = true; // 开启全局loading
      try {
        // 获取字典数据
        const dict = await GlobalData.getDictList(['ACW_ENROLLMENT_STATUS']);
        this.enrollmentStatusList = initSelectedData((dict.ACW_ENROLLMENT_STATUS?.filter(item => ['ENROLLING', 'ENROLLED', 'ENROLLMENT_FAILED', 'DISENROLLING', 'DISENROLLED'].includes(item.value))), 'description', 'value', false);

        const res = await AccountInfo.getAccountInfo();
        if (res.profile) {
          const profile = JSON.parse(res.profile);
          console.log('------------profile------------', profile);
          this.profile = profile;

          // 处理通知状态
          if (profile.acwEnrollmentNotifySupportStatus) {
            this.checkStatusList = profile.acwEnrollmentNotifySupportStatus.split(',');
          } else {
            // 默认选中所有状态
            this.checkStatusList = this.enrollmentStatusList.map(item => item.value);
          }

          // 处理Webhook通知
          this.notifyWebhook = profile.acwEnrollmentNotifyWebhook || '';
          this.isWebhookChecked = !!profile.acwEnrollmentNotifyWebhook;

          // 处理Email通知
          this.notifyEmail = profile.acwEnrollmentNotifyEmail || '';
          this.isEmailChecked = !!profile.acwEnrollmentNotifyEmail;

          // 其他通知设置
          this.notifyEthocaWebhook = profile.ethocaAcwNotifyWebhook;
          this.isEthocaWebhookChecked = !!profile.ethocaAcwNotifyWebhook;
          this.isRDRSFTPChecked = `${profile.enableRdrAcwNotify}` === 'true';

          // 欺诈通知设置
          this.notifyFraudWebhook = profile.fraudNotifyWebhook || ''; // 初始化欺诈通知Webhook地址
          this.isFraudWebhookChecked = !!profile.fraudNotifyWebhook; // 根据是否有配置地址来确定是否选中
        } else {
          this.profile = {};
        }
      } finally {
        this.dataLoading = false; // 无论成功还是失败，都关闭loading
      }
    },
    // 获取状态标签的辅助方法
    getStatusLabel(value) {
      const option = this.enrollmentStatusList.find(item => item.value === value);
      return option ? option.label : value;
    },
    handleOperationClick(key) {
      this.operation[key] = !this.operation[key];
    },
    handleSaveEnrollmentNotify() {
      // 验证通知状态至少选择一项
      if (this.checkStatusList.length === 0) {
        ShowErrorMessage(this.$t('message.validator.select', { select: this.$t('message.developer.notifyStatus').toLowerCase() }));
        return;
      }

      // 验证通知方式至少选择一项
      if (!this.isWebhookChecked && !this.isEmailChecked) {
        ShowErrorMessage(this.$t('message.validator.select', { select: this.$t('message.developer.selectNotifyType').toLowerCase() }));
        return;
      }

      // 通知方式是可选的，但如果选中了某种通知方式，则必须填写对应的值
      if (this.isWebhookChecked && !this.notifyWebhook) {
        ShowErrorMessage(this.$t('message.validator.input', { input: this.$t('message.developer.webhook').toLowerCase() }));
        return;
      }

      if (this.isEmailChecked && !this.notifyEmail) {
        ShowErrorMessage(this.$t('message.validator.input', { input: this.$t('message.developer.email').toLowerCase() }));
        return;
      }

      this.operation.isEditEnrollmentNotify = false;

      this.onSave({
        acwEnrollmentNotifySupportStatus: this.checkStatusList.join(','),
        acwEnrollmentNotifyWebhook: this.isWebhookChecked ? this.notifyWebhook : '',
        acwEnrollmentNotifyEmail: this.isEmailChecked ? this.notifyEmail : '',
      });
    },
    handleSaveEthocaAlerts() {
      if (this.isEthocaWebhookChecked && !this.notifyEthocaWebhook) {
        ShowErrorMessage(this.$t('message.validator.input', { input: this.$t('message.developer.webhook').toLowerCase() }));
        return;
      }
      this.operation.isEditEthocaAlerts = false;
      this.onSave({
        ethocaAcwNotifyWebhook: this.isEthocaWebhookChecked ? this.notifyEthocaWebhook : '',
      });
    },
    handleSaveRDRCases() {
      this.operation.isEditRDRCases = false;
      this.onSave({
        enableRdrAcwNotify: this.isRDRSFTPChecked,
      });
    },
    handleSaveFraudNotify() {
      // 如果选中了Webhook通知方式，必须填写通知地址
      if (this.isFraudWebhookChecked && !this.notifyFraudWebhook) {
        ShowErrorMessage(this.$t('message.validator.input', { input: this.$t('message.developer.webhook').toLowerCase() }));
        return;
      }

      this.operation.isEditFraudNotify = false; // 保存后关闭编辑状态
      this.onSave({
        fraudNotifyWebhook: this.isFraudWebhookChecked ? this.notifyFraudWebhook : '', // 根据选中状态保存Webhook地址或空字符串
      });
    },
    async onSave(data) {
      try {
        this.dataLoading = true;
        await updateMerchantProfile({ profile: JSON.stringify(data) });
        ShowSuccessMessage(this.$t('message.settingsSuccessfulTip'));
      } finally {
        this.dataLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scope>
@import '@/styles/variables.scss';

.notify-box {
  min-height: 166px;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px 3px rgba(0,0,0,0.05);
  border-radius: 25px 25px 25px 25px;
  margin-top: 30px;
  padding-left: 30px;
  padding-right: 36px;

  .notify-title {
    font-weight: 600;
    font-size: 14px;
    color: $color-text-primary;
  }

  .notify-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    border-bottom: 1px solid #EBEEF0;
    margin-bottom: 20px;

    .icon-tishi003 {
      color: rgba($color: #43618A, $alpha: .7);
      font-size: 14px;
    }

    .el-button {
      .iconfont {
        margin-right: 8px;
      }
    }
  }

  .notify-content {
    padding-bottom: 30px;

    .el-form-item {
      margin-bottom: 0;
    }

    .el-checkbox {
      width: max-content;
    }

    .el-checkbox .el-checkbox__inner {
      width: 18px;
      height: 18px;
      box-sizing: border-box;

      &::after {
        height: 10px;
        left: 6px;
      }
    }

    .el-checkbox__label {
      font-weight: 600 !important;
      color: rgba(0,32,63,0.6) !important;
    }

    .notify-item {
      display: flex;
      flex-direction: column;
    }

    .value-input {
      width: 360px;
    }
  }
}
</style>
